import { Controller } from "@hotwired/stimulus"

import Swal from 'sweetalert2';

import axios from 'axios';
import getFriendlyErrorMessage from '../../javascript/helpers/getFriendlyErrorMessage';

import { hideModalCarregando, showModalCarregando } from "../../javascript/modal-carregando";

export default class extends Controller {
  static targets = ["checkbox", "checkAllCheckbox"]

  quantidadeSelecionados = 0;

  connect() {
    console.log('tabela-relatorios connected');
    // Reset contador ao conectar para garantir estado inicial correto
    this.quantidadeSelecionados = this.getSelectedIds().length;
  }


  toggleAll(event) {
    const checked = event.target.checked;
    
    // Seleciona ou deseleciona todos os checkboxes visíveis na página atual
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked;
    });
    
    // Atualiza o contador baseado no estado atual
    this.quantidadeSelecionados = checked ? this.checkboxTargets.length : 0;
  }

  toogle(event) {
    const checked = event.target.checked;
    const id = event.target.value;

    if (checked) {
      this.quantidadeSelecionados++;
    } else {
      this.quantidadeSelecionados--;
      if (this.checkAllCheckboxTarget && this.checkAllCheckboxTarget.checked) {
        this.checkAllCheckboxTarget.checked = false;
      }
    }

    // Atualiza o estado do checkbox "selecionar todos" baseado na quantidade selecionada
    if (this.checkAllCheckboxTarget) {
      const totalCheckboxes = this.checkboxTargets.length;
      this.checkAllCheckboxTarget.checked = (this.quantidadeSelecionados === totalCheckboxes && totalCheckboxes > 0);
    }
  }

  async visualizarEmLote() {
    if (!this.verificarPodeRealizarAcao()) {
      return;
    }
    const selectedIds = this.getSelectedIds();

    const result = await Swal.fire({
      title: "Aviso",
      text: `Deseja visualizar em lote ${selectedIds.length} selecionados?`,
      confirmButtonText: "Sim, Visualizar",
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar"
    });

    if (!result.isConfirmed) return;

    try {
      showModalCarregando('Processando... Por favor aguarde, essa operação pode levar alguns minutos.');
      const response = await axios.post("/validar-relatorios/visualizar_relatorios_em_lote", {
        ids: selectedIds
      }, {
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));

      const link = document.createElement('a');
      link.href = url;

      const nomeArquivo = `relatorios-sgf-${this.getDataHoraAtual()}.pdf`;

      link.setAttribute('download', nomeArquivo);

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      this.exibirErro(err);
    } finally {
      hideModalCarregando();
    }
  }

  async aprovarEmLote() {
    if (!this.verificarPodeRealizarAcao()) {
      return;
    }
    const selectedIds = this.getSelectedIds();

    const result = await Swal.fire({
      title: "Aviso",
      text: `Deseja aprovar em lote ${selectedIds.length} relatórios?`,
      confirmButtonText: "Sim, Aprovar",
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar"
    })
    if (result.isConfirmed) {
      try {
        showModalCarregando('Processando... Por favor aguarde, essa operação pode levar alguns minutos.');

        const { data } = await axios.post("/validar-relatorios/aprovar_relatorios_em_lote", {
          ids: selectedIds
        });
        hideModalCarregando();
        await Swal.fire({
          title: "Sucesso",
          text: data.mensagem
        });
        location.reload();
      } catch (err) {
        this.exibirErro(err);
        hideModalCarregando();
      }
    }
  }

  verificarPodeRealizarAcao() {
    const selectedIds = this.getSelectedIds();

    if (selectedIds.length == 0) {
      Swal.fire({
        title: "Aviso",
        text: "Nenhum relatório selecionado"
      })
      return false;
    }
    return true;
  }

  getSelectedIds() {
    return this.checkboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)
  }

  getDataHoraAtual() {
    // Não consegui formatar a data do jeito que preciso usando funções pré-existentes do JS, então tive que criar a minha - bruno
    // Fonte: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts
    const options = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    };

    const dataHora = new Intl.DateTimeFormat('pt-BR', options).formatToParts(new Date()).map((p) => p.value);

    // formato: ano-mes-dia--hora-minuto-segundo
    return dataHora[4] + '-' + dataHora[2] + '-' + dataHora[0] + '--' + dataHora[6] + '-' + dataHora[8] + '-' + dataHora[10]
  }

  exibirErro(err) {
    // Tenta tratar erros que retornaram um blob com JSON
    if (err.response && err.response.data instanceof Blob) {
      const contentType = err.response.headers["content-type"];

      if (contentType && contentType.includes("application/json")) {
        const reader = new FileReader();

        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result);
            console.log(errorData)
            const message = errorData.mensagem || "Erro inesperado ao processar o PDF.";
            Swal.fire({ title: "Erro", text: message });
          } catch (e) {
            // JSON inválido
            Swal.fire({
              title: "Erro",
              text: "Erro inesperado ao processar a resposta de erro."
            });
          }
        };

        reader.readAsText(err.response.data);
        return;
      }
    }

    // Fallback genérico
    console.error(err);
    const message = getFriendlyErrorMessage(err, "Houve um erro ao processar os dados. Por favor, tente novamente");
    Swal.fire({
      title: "Erro",
      text: message
    });
  }
}